/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 */

import TitleAndMetaTags from './TitleAndMetaTags';

export default TitleAndMetaTags;
